import React from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { useStrings } from "../../localization/localizationHelpers";
import { getOrdersInfoArray } from "../../redux/selectors";
import { FieldOption } from "../../server/edsApi/models/forms";
import * as styles from "./DevKitOrders.module.css";

// Mock order for testing
/* const mockOrderToShow: FieldOption = {
  orderId: 12345,
  offerName: "Xbox Dev Kit Model X",
  skuId: "SKU-001",
  skuName: "Dev Kit SKU",
  quantity: 2,
  shippingAddress1: "123 Main St",
  shippingAddress2: "Apt 4B",
  shippingCity: "Redmond",
  shippingStateProvince: "WA",
  shippingCountryOrRegion: "USA",
  shippingZipPostalCode: "98052",
  orderStatus: "Shipped",
  carrier: "FedEx",
  trackingNumber: "1234567890",
};
*/

export const DevKitOrders = () => {
  const [
    welcomePartnerPageDevsKitTitle,
    welcomePartnerPageDevsKitDescription,
    model,
    quantity,
    address,
    status,
  ] = useStrings(
    "welcomePartnerPageDevsKitTitle",
    "welcomePartnerPageDevsKitDescription",
    "model",
    "quantity",
    "address",
    "status"
  );

  const orders: FieldOption[] | undefined = useSelector(getOrdersInfoArray);
  const orderToShow = orders && orders[0] ? orders[0] : null;

  if (!orderToShow) {
    return null;
  }

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h2 className={styles.cardTitle}>{welcomePartnerPageDevsKitTitle}</h2>
        <p className={styles.cardSubtitle}>{welcomePartnerPageDevsKitDescription}</p>
      </div>
      <Column>
        <Row className={styles.welcomeParterPageDevsKitContainerRow}>
          <Column className={styles.welcomeParterPageDevsKitContentRow}>
            <h3 className={styles.studioDevKitsSectionTitle}>{model}</h3>
            <p className={styles.studioDevKitsSectionContent}>{orderToShow.offerName}</p>
          </Column>
          <Column className={styles.welcomeParterPageDevsKitContentRow}>
            <h3 className={styles.studioDevKitsSectionTitle}>{quantity}</h3>
            <p className={styles.studioDevKitsSectionContent}>{orderToShow.quantity}</p>
          </Column>
          <Column className={styles.welcomeParterPageDevsKitContentRow}>
            <Row>
              <h3 className={styles.studioDevKitsSectionTitle}>{address}</h3>
            </Row>
            <Row>
              <p className={styles.studioDevKitsSectionContent}>{orderToShow.shippingAddress1}</p>
            </Row>
            {orderToShow.shippingAddress2 && (
              <Row>
                <p className={styles.studioDevKitsSectionContent}>{orderToShow.shippingAddress2}</p>
              </Row>
            )}
          </Column>
          <Column className={styles.welcomeParterPageDevsKitContentRow}>
            <h3 className={styles.studioDevKitsSectionTitle}>{status}</h3>
            <p className={styles.studioDevKitsSectionContent}>{orderToShow.orderStatus}</p>
          </Column>
        </Row>
      </Column>
    </div>
  );
};
